export function insertBlockFromDb(blocks, id){
    const boilerplate = {}
    blocks.forEach((block) => {
        const blockId = block.id.toString();
        boilerplate[blockId] = {
        type: block.type,
        parent: block.parent,
        data: block.data
        };
        if (block.childrenIds){
        if(block.type == "Ruleset"){
            for (let index = 0;  index < block.data.props.rules.length; index++){
           block.data.props.rules[index].conditionalBlock = block.childrenIds[index].toString();
            }
        }
        block.data.props.childrenIds = block.childrenIds.map(num => num.toString());
        }
        if (block.childrenIds && block.data.props.columns) {
        for (let columnIndex = 0; columnIndex <  block.data.props.columns.length; columnIndex++) {
            if(block.childrenIds[columnIndex]) block.data.props.columns[columnIndex].childrenIds[0]= block.childrenIds[columnIndex].toString();
        }
        }

        
    });
    return boilerplate
}
